/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdInfo } from 'react-icons/md';
import { formatCurrency } from '../../helper-utils/appUtils';
import { useAppContext } from '../../../saas/AppConfigWrapper';

function BreakupRow({ title, value }) {
  return (
    <div className="fare-breakup_content">
      <div className="fare-breakup_title">{title}</div>
      <div className="fare-breakup_value">{value}</div>
    </div>
  );
}

BreakupRow.propTypes = {
  title: PropTypes.node.isRequired,
  value: PropTypes.node,
};

BreakupRow.defaultProps = {
  value: '',
};

/**
 * Fare breakup info icon + tooltip shown next to the fare price.
 * `isPaxWise` renders the adult / child / infant split used by branded fares.
 */
function FareBreakup({ fare, showInvoiceFare, isPaxWise, searchRequest }) {
  const { appConfig } = useAppContext();
  const gstLabel = appConfig?.isIntlClient === 'true' ? 'VAT' : 'GST';
  const numAdults = parseInt(searchRequest?.numadults, 10) || 0;
  const numChildren = parseInt(searchRequest?.numchildren, 10) || 0;
  const numInfants = parseInt(searchRequest?.numinfants, 10) || 0;

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="fare-breakup-tooltip">
          <div className="fare-breakup">
            {isPaxWise ? (
              <>
                <BreakupRow
                  title={`Adult *${numAdults}`}
                  value={formatCurrency(
                    fare.adultbasefare + fare.adulttax + fare.transactionfee,
                  )}
                />
                {numChildren > 0 && (
                  <BreakupRow
                    title={`Child *${numChildren}`}
                    value={formatCurrency(
                      fare.childbasefare + fare.childtax + fare.transactionfee,
                    )}
                  />
                )}
                {numInfants > 0 && (
                  <BreakupRow
                    title={`Infant *${numInfants}`}
                    value={formatCurrency(fare.infantbasefare + fare.infanttax)}
                  />
                )}
              </>
            ) : (
              <>
                <BreakupRow
                  title="Base Fare"
                  value={formatCurrency(fare.totalbasefare)}
                />
                <BreakupRow title="Tax" value={formatCurrency(fare.totaltax)} />
                <BreakupRow
                  title="HC"
                  value={formatCurrency(fare.handlingcharges)}
                />
              </>
            )}
            <BreakupRow
              title={gstLabel}
              value={formatCurrency(fare.servicetax)}
            />
            <BreakupRow
              title="Other Charges"
              value={formatCurrency(fare.transactionfee)}
            />
            {showInvoiceFare && (
              <>
                <BreakupRow
                  title="Discount"
                  value={formatCurrency(fare.discount)}
                />
                <BreakupRow title="TDS" value={formatCurrency(fare.tds)} />
                <BreakupRow
                  title="Net Fare"
                  value={formatCurrency(fare.totalnet)}
                />
              </>
            )}
            <BreakupRow
              title="Total Fare"
              value={formatCurrency(fare.totalfq)}
            />
          </div>
        </Tooltip>
      }
    >
      <div className="cursor-pointer secondary-color d-flex">
        <MdInfo />
      </div>
    </OverlayTrigger>
  );
}

FareBreakup.propTypes = {
  fare: PropTypes.object.isRequired,
  showInvoiceFare: PropTypes.bool,
  isPaxWise: PropTypes.bool,
  searchRequest: PropTypes.object,
};

FareBreakup.defaultProps = {
  showInvoiceFare: false,
  isPaxWise: false,
  searchRequest: {},
};

export default FareBreakup;
